export default __webpack_public_path__ + "static/media/service-img-2.266c8ac9.png";